import {gql} from '@apollo/client';

export const BCP_CHECK_USER_GROUPS = gql`
    query BcpCheckUserGroups($id: Long, $groupName: String, $pageRequest: PageRequestTypeInput) {
        bcpCheckUserGroups(id: $id, groupName: $groupName, pageRequest: $pageRequest) {
            success
            code
            message
            content {
                id
                groupName
                remark
                createUser
                createTime
                users
            }
            pageInfo {
                page
                size
                totalElements
                totalPages
                hasNext
                hasPrevious
            }
        }
    }
`;

export const BCP_CHECK_USER_GROUP = gql`
    query BcpCheckUserGroup($id: Long!) {
        bcpCheckUserGroup(id: $id) {
            success
            code
            message
            data {
                id
                groupName
                remark
                createUser
                createTime
                users
            }
        }
    }
`;
